const getFileExt = (fileName) => {
  const extensionPattern = /(?:\.([^.]+))?$/
  return extensionPattern.exec(fileName)[1]
}

export default getFileExt
